import _sfc_main from "./NotificationBell.vue2.js";
/* empty css                      */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const NotificationBell = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-cd0b0198"]]);
export {
  NotificationBell as default
};
//# sourceMappingURL=NotificationBell.vue.js.map
